import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";

/** One delayed foreground indicator. Background refreshes must not acquire it. */
@Injectable({ providedIn: "root" })
export class DelayedSpinnerService {
  private readonly delayMs = 300;
  private timeoutHandle: ReturnType<typeof setTimeout>;
  private visible = false;
  private legacyPending = false;
  private readonly preparations = new Set<object>();

  constructor(private spinner: NgxSpinnerService) {}

  /** Independent preparation with an idempotent release for complete/error/cancel. */
  public acquire(): () => void {
    const owner = {};
    this.preparations.add(owner);
    this.update();
    return () => { this.preparations.delete(owner); this.update(); };
  }

  // Preserve legacy idempotent show/hide semantics for existing screen actions.
  public show(): void { this.legacyPending = true; this.update(); }
  public hide(): void { this.legacyPending = false; this.update(); }

  private update(): void {
    if (this.legacyPending || this.preparations.size > 0) {
      if (!this.visible && !this.timeoutHandle) {
        this.timeoutHandle = setTimeout(() => {
          this.timeoutHandle = null;
          this.visible = true;
          this.spinner.show();
        }, this.delayMs);
      }
      return;
    }
    clearTimeout(this.timeoutHandle);
    this.timeoutHandle = null;
    if (this.visible) {
      this.visible = false;
      this.spinner.hide();
    }
  }
}
